define( [
	"../var/pnum"
], function( pnum ) {

return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );

} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/rcssNum.js
 ** module id = 829
 ** module chunks = 2
 **/